import React, { Component } from 'react'
import RadioButton from '../common/radioButton'
import RadioGroup from '../common/radioGroup'
import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'
import Checkbox from '../common/checkbox'
import Privacy from '../common/privacy'
import Controls from '../common/controls'
import RegexVerification from './regex_verification'

class Genetics extends Component {
  constructor(props) {
    super(props)
    this.props.updateActivePage(2)

    this.state = {
      input: {
        geneticConsent: { value: '', type: 'radio', required: true },
        geneticConsentInitial: { value: '', type: 'text', required: false },
        geneticReleaseCheck: { value: false, type: 'checkbox', required: false },
        geneticReleaseInitial: { value: '', type: 'text', required: false },
      },
      submitClick: false
    }

    this.require = { 
      geneticConsent: { value: 'agree', items: ['geneticConsentInitial', 'geneticReleaseCheck', 'geneticReleaseInitial'] }
    }


    this.focusElements = {}

    for (let name in this.state.input) {
      this.focusElements[name] = React.createRef()
    }

    document.title = "Genetic Test"
    this.next = this._next.bind(this)
  }

  setRequired(name) {

    if (this.require[name]) {
      const isRequired = this.require[name].value === this.state.input[name].value
      let newInputState = {}
      for (let i = 0; i < this.require[name].items.length; ++i) {
        const item = this.require[name].items[i]
        newInputState[item] = { 
          value: this.state.input[item].value,
          type: this.state.input[item].type,
          required: isRequired
        }
      }
      this.setState({
        input: { 
          ...this.state.input,
          ...newInputState
        }
      })

      this.setState({ 
        submitClick: false 
      })
    }
  }

  handleChange(name, valueOrEvent) {
    if (name === 'geneticConsent' && valueOrEvent === 'decline'){
      let newState =  this.state
      newState.input.geneticConsentInitial.value = ''
      this.setState(newState)
    }
    switch (this.state.input[name].type) {
      case 'text':
        const curInputValue = valueOrEvent.target.value
        this.handleStateChange(name, curInputValue)
        break
      case 'checkbox':
        this.handleStateChange(name, !this.state.input[name].value)
        break
      case 'radio':
        this.handleStateChange(name, valueOrEvent)
        break
      default: 
        break
    }
  }

  handleStateChange(name, value) {
    this.setState({ 
      input: { ...this.state.input,
        [name]: {...this.state.input[name], 
          value: value 
        }
      }
    }, () => {
      this.setRequired(name)
    })
  }

  _next(e) {
    e.preventDefault()
    this.setState({ submitClick: true })
    for (let property in this.state.input) {
      if (!this.isValid(property)) {
        this.focusElements[property].focus()
        return
      }
    }
    return this.props.next(this.props.match.path, this.state)
  }

  isEmpty(name) {
    if (this.state.input[name].value === '') return true
    return false
  }

  isValid(name) {
    if (this.state.input[name].required === false) return true
    switch (this.state.input[name].type) {
      case 'radio':
        return !this.isEmpty(name)
      case 'checkbox':
        return this.state.input[name].value
      case 'text':
        return RegexVerification[name].test(this.state.input[name].value)
      default:
    }
  }

  verificationError() {
    let errorText = ""
    if (this.props.verError) {
      errorText = "The values entered do not match our records. Please review your entry or call Client Care at 1-888-639-8181."
    }
    return (
      <div aria-live="polite" className="error">{errorText}</div>
    )
  }

  displayError(name, errorId) {
    if (this.state.submitClick) {
      if (!this.isValid(name)) {
        switch (this.state.input[name].type) {
          case 'radio':
            return (
              <div className="error" id={errorId}>This field is required.</div>
            )
          case 'checkbox':
            return (
              <div className="error" id={errorId}>You must agree before continuing</div>
            )
          case 'text':
            if (this.isEmpty(name)) {
              return (
                <div className="error" id={errorId}>This field is required.</div>
              )
            }
            return (
              <div className="error" id={errorId}>At least two initial letters are required.</div>
            )
          default:
        }
      }
    }
    return (
      <div className="error" id={errorId}></div>
    )
  }

  makeRef(name, ref) {
    this.focusElements[name] = ref
  }

  initials(name) {
    let initialName
    switch (name) {
      case 'genetic-consent':
        initialName = 'geneticConsentInitial'
        break
      case 'genetic-release':
        initialName = 'geneticReleaseInitial'
        break
      default: 
        initialName = ''
    }
    
    return (
      <span>
        <div className="form-input">
          <h3 id={`welcome_genetics_${name}_initials_text`} tabIndex="-1">Enter Your Initials:</h3>
          <input
            ref={this.makeRef.bind(this, initialName)}
            value={this.state.input[initialName].value}
            id={`welcome_genetics_${name}_initials`}
            type="text"
            placeholder="Enter initials here"
            aria-labelledby={`welcome_genetics_${name}_initials_text welcome_genetics_${name}_initials_description`}
            aria-describedby={`welcome_genetics_${name}_initials_error`}
            onChange={this.handleChange.bind(this, initialName)}
            data-atid={`welcome_gen_${name}_initials`}
          />
        </div>
        {this.displayError(initialName, `welcome_genetics_${name}_initials_error`)}
        <p id={`welcome_genetics_${name}_initials_description`} tabIndex="-1">By entering my initials here and clicking Next, I agree to the Newtopia Genetics Consent. I understand and agree that by doing so, I am electronically signing the Genetics Consent, that the check mark has the same effect as a pen-and-paper signature, and that I am entering into a valid and binding agreement as the individual named above or as the individual's authorized representative.</p>
      </span>
    )
  }

  componentDidMount() {
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus()
    window.scrollTo(0, 0)
  }

  geneticsAgreement() {
    const geneticConsentInitials = this.initials('genetic-consent')
    const agreeLabel = <span>I have read and agree to the terms of the <a href="https://newtopia.com/b2c/consent-for-genetics-testing/" target="_blank" rel="noopener noreferrer">Consent for Genetics Testing</a></span>
    const declineLabel = 'I have read and choose to decline the genetic testing component of the Programs'

    return (
      <div>
        <h3>Consent for Genetics Testing</h3>
        <div className="policy-box">
          <div className="policy-box-content" tabIndex="0" id="genetic_consent">
            <p>By signing below, I consent to the collection of specimens from myself (or individual who lacks capacity for consent) for the purpose of Newtopia Genetics DNA testing. I understand that the Newtopia Genetics TM testing is for research and educational use only. Newtopia Genetics is not a genetic testing lab, a medical genetics company, or a clinical service. Newtopia Genetics is not designed to diagnose disease or medical conditions, and it is not intended to provide medical advice. If you have concerns or questions about what you learn through your Newtopia Genetics test, you should discuss them with your Newtopia Coach, your physician, or both.</p>
            <p>Newtopia will use the information from a physician prescribed genetic test, gathered and analyzed by a certified independent laboratory, for research study purposes and to guide the customization of personalized lifestyle plans combining nutrition, exercise and behavior management in connection with the Newtopia programs and offerings (collectively, “Newtopia Programs”) in which I participate. I understand that my sample will be sent to a laboratory working with Newtopia (the “Lab”) to identify genetic markers and characteristics that may affect my overall health and wellbeing and which are relevant to my participation in the Newtopia Programs. These include characteristics that influence appetite, body fat, cravings, stress, resiliency, behavior and habits. These markers are being tested in connection with my participation in the Newtopia Programs and to aid Newtopia in the customization of the Newtopia Programs for me. The results of these tests may assist Newtopia with making recommendations to me and in the development of an individualized lifestyle plan combining nutrition, exercise, and behavior management.</p>
            <p>I understand that a positive (abnormal) test result may provide insight into what may be influencing my overall health and wellbeing and will allow Newtopia to customize my participation in the Newtopia Programs, including recommendations for nutrient distribution, activity intensity, and lifestyle modification. I understand that I may wish to consider further independent testing, consult my physician or pursue genetic counseling. The genetic testing being performed is not comprehensive and thus my test results may be negative even if I have a genetic condition because genetic markers that are not being tested or yet discovered are not detected. I understand that genetic test results may be unclear or difficult to interpret due to current understanding of genetic disorders or conditions and/or technical limitations of the test and that the results are not intended to be used as the sole means for clinical diagnosis or patient care decisions. Predicted gene function may change depending upon the emergence of new discoveries, literature, industry standards and guidelines. I may want to have genetic counseling prior to signing this consent. No tests other than those authorized shall be done.</p>
            <p>I understand that: while DNA testing is highly accurate and widely accepted, as in all testing there is a possibility of delay or error; the Lab may use reference laboratories; the Lab and Newtopia may contact me to obtain additional specimens for testing; and the Lab and Newtopia maintain patient privacy in accordance with HIPAA, as applicable. I understand that my data and specimen, without information typically used to identify me (e.g., name, address, date of birth), may be stored indefinitely by the Lab and/or Newtopia and used or disclosed to third parties for quality assurance, research studies or medical education purposes, including additional genetic testing of my sample for such purposes without information typically used to identify me (e.g., name, address, date of birth). I may request disposal of my sample up to 60 days after the completion of my test by contacting the Lab or Newtopia (New York State residents: sample shall be destroyed within 60 days of collection). I understand that my results (other than those for research or education on non-identifiable samples) will be shared with my provider who ordered the test. I agree to relinquish the Lab, Newtopia and its representatives from liability for injury that may arise from collecting and testing these specimens and from any effects or actions that the results of these tests may have on me or any other individual. I have been given the opportunity to ask questions regarding purpose, test reliability/ limitations, risks and benefits. I understand that genetic tests may result in my learning information about myself that I do not anticipate and that genetic testing can involve possible medical, psychological or insurance consequences for me. I also understand that sharing my genetic results with others could negatively affect me. My participation in this genetic testing is completely voluntary and I understand my results will be sent to the ordering physician or facility, and Newtopia in accordance with my Newtopia Authorization to Use and Disclose Genetic Information form.</p>
          </div>
        </div>
        <p>Note: For residents of New York we currently are not able to offer genetic testing.</p>

        <RadioGroup 
          name="genetic-consent" 
          radioRef={this.makeRef.bind(this, "geneticConsent")} 
          onChange={this.handleChange.bind(this, "geneticConsent")} 
          ariaDescribedby="welcome_genetics_geneticConsent_error"
          dataAtId="welcome_gen_geneticConsent"
        >
          <RadioButton value="agree" label={agreeLabel}/>
          <RadioButton value="decline" label={declineLabel} />
        </RadioGroup>
        {geneticConsentInitials}
        {this.displayError("geneticConsent", "welcome_genetics_geneticConsent_error")}
      </div>
    )
  }

  geneticReleasePolicyBox() {
    return (
      <div className="policy-box" tabIndex="0">
        <div className="policy-box-content">
          By signing this Authorization for the Release of Genetic Information (“Authorization”), I authorize the following:
          <ul>
            <li>• I authorize the laboratory working with Newtopia and any other laboratories performing my genetic tests to disclose the results of my genetic markers and characteristics for FTO (the body fat gene), MC4R (the appetite gene), DRD2 (the cravings gene), BDNF (the stress and resiliency gene), and any other genetic characteristics that are relevant to my participation in the Newtopia programs and offerings (collectively, “Newtopia Programs”), including those that may influence my behaviors, habits and overall health and wellbeing, along with my demographic information, including my name, date of birth, and contact information (collectively, “Genetic Information”) to Newtopia, Inc., 4101 Yonge Street, Suite 706, Toronto, ON M2P1N6, for use in connection with the Newtopia Programs and for Newtopia to provide me with the results of my genetic tests. </li>
            <li>• I authorize Newtopia, Inc., its workforce, subsidiaries, subcontractors, agents and affiliated entities (collectively, “Newtopia”) to disclose my Genetic Information, to my Newtopia Coach, and the provider organization approving my eligibility for genetic testing.</li>
            <li>• I authorize Newtopia to use and disclose to third party researchers my Genetic Information and other information collected about me through the Newtopia Programs without information typically used to identify me (e.g., name, address, date of birth) for purposes of conducting future genetic and scientific research. I understand that the results of such research will not be shared with me; may be published in a manner that would not identify me; and that I will not receive any financial benefit from such research or any products or services resulting from such research.</li>
            <li>• I understand that Newtopia will never share my genetic testing results with my employer. </li>
          </ul>
          <p>I understand that once my Genetic Information has been disclosed, federal privacy laws may no longer protect my Genetic Information. I understand that this Authorization is voluntary and that my treatment, payment for treatment, enrollment or eligibility will not be conditioned on whether I refuse to sign this Authorization. If I do not sign this Authorization, however, I may not be able to participate in certain related aspects of the Newtopia Programs. </p>
          <p>I understand that I may revoke this Authorization at any time and for any reason by writing to Newtopia at <a href="mailto:privacy@newtopia.com">privacy@newtopia.com</a>. I understand that my revocation will not be effective for information already used and disclosed in reliance on my Authorization. By signing this Authorization, I authorize Newtopia to retain my Genetic Information until the expiration date of this Authorization, until I revoke this Authorization, or until I request that my Genetic Information be destroyed.</p>
          <p>This Authorization will expire as of the date on which I have graduated from the Newtopia Programs, or am no longer covered under my employer’s health benefit plan, unless authorization is revoked by me or an earlier expiration date is required by applicable law. I understand that I am entitled to receive a copy of this Authorization once it has been signed.</p>
        </div>
      </div>
    )
  }

  geneticsRelease() {
    const geneticReleaseInitials = this.initials("genetic-release")
    const agreeLabel = <span>I have read and agree to the terms of the <a href="https://newtopia.com/b2c/newtopia-authorization-for-release-of-genetic-information/" target="_blank" rel="noopener noreferrer">Newtopia Authorization for Release of Genetic Information</a></span>
    
    return (
      <div>
        {this.state.input.geneticConsent.value === 'agree' &&
          <h3>Newtopia Authorization for Release of Genetic Information</h3>
        }
        <div aria-live="polite" id="genetic_release">
          {this.state.input.geneticConsent.value === 'agree' &&
            this.geneticReleasePolicyBox()
          }
        </div>
        {this.state.input.geneticConsent.value === 'agree' &&
          <div>
            <Checkbox 
              checkboxRef={this.makeRef.bind(this, "geneticReleaseCheck")} 
              checked={this.state.input.geneticReleaseCheck.value} 
              onChange={this.handleChange.bind(this, "geneticReleaseCheck")} 
              value="genetic-release" 
              ariaDescribedby="welcome_genetics_geneticReleaseCheck_error"
              info={agreeLabel}
              dataAtId="welcome_gen" 
            />
            {this.displayError("geneticReleaseCheck", "welcome_genetics_geneticReleaseCheck_error")}
            {geneticReleaseInitials}
          </div>
        }
      </div>
    )  
  }

  render() {
    const geneticsAgreement = this.geneticsAgreement()
    const geneticsRelease = this.geneticsRelease()
    return (
      <div id="genetics">
        <AriaMessage message="Navigated to genetic consent page" />
        <Title>The Genetic Test</Title> 
        <div className="container form-container">
          <h2>The Genetic Test</h2>
          <div className="genetic-info">
            <div className="genetic-info-item">
              <p><strong>What is the genetic test?</strong></p>
              <p>The genetic test is a simple cheek swab. You painlessly rub the provided cotton swab against the inside of your cheek and place it in an envelope. We will provide you with a mailing envelope to send your swab directly to the lab. It's as simple as that!</p>
              <p><strong>What will the results tell me?</strong></p>
              <p>We identify genetic markers and characteristics that may affect your overall health and well-being. These include characteristics that influence appetite, body fat, sleep, stress, resiliency, activity, and other lifestyle habits. Understanding these genes will help your Inspirator make the best recommendations for you.</p>
              <p className="genetic-subnote">Interested in taking a genetic test? Agree to the consent forms below and a test will be sent to you as part of your Welcome Kit.</p>
            </div>
            <img className="gen-img" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/c26e3757-6b0d-408b-bd3b-1788401845a2.png" alt="Test Tube"/>
          </div>
          {geneticsAgreement} 
          {geneticsRelease}
          <Privacy />
          <Controls dataAtId="welcome_gen" next={this.next} />
          {this.verificationError()}
        </div>
      </div>
    )
  }
}

export default Genetics